export default {
  entering: {
    transform: 'translate3d(0, -50%, 0)',
  },
};
